import {Link} from 'gatsby';
import React from 'react';

import logo from '_images/logo-v2.svg';

const currentYear = new Date().getFullYear();

const Footer = () => (
  <div className="py-10 lg:py-12 px-4 lg:px-20 flex flex-col lg:flex-row justify-between lg:items-end gap-10 lg:gap-20 bg-[#060606]">
    <div className="">
      <img src={logo} className="w-[158px] lg:w-[316px]" alt="SunnysideSG" />
    </div>
    <div className="">
      <div className="font-nh text-sm lg:text-base font-semibold text-white flex flex-col lg:flex-row gap-4 lg:gap-10">
        <span>SunnySide Homes Pte Ltd. All Rights Reserved {currentYear}.</span>
        <a className="" href="/privacy" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
        <a className="" href="/terms" target="_blank" rel="noreferrer">
          Terms
        </a>
      </div>
    </div>
  </div>
);

export default Footer;
